import { render, staticRenderFns } from "./6BvnVerify.vue?vue&type=template&id=58988ec2&scoped=true"
import script from "./6BvnVerify.vue?vue&type=script&lang=js"
export * from "./6BvnVerify.vue?vue&type=script&lang=js"
import style0 from "./6BvnVerify.vue?vue&type=style&index=0&id=58988ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58988ec2",
  null
  
)

export default component.exports